if (!customElements.get('pacifica-product-form')) {
  customElements.define('pacifica-product-form', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.form = this.querySelector('form');
      this.button = this.form.querySelector('[type="submit"]');
      this.error = this.querySelector('.pf-cart-error');
      this.form.addEventListener('submit', event => this.add(event));
    }

    async add(event) {
      event.preventDefault();
      if (this.busy || this.button.disabled || !this.form.reportValidity()) return;
      this.busy = true;
      this.button.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const dialog = this.closest('dialog');
      const preview = dialog?.closest('pacifica-quick-preview');
      const body = new FormData(this.form);
      if (cart) {
        body.append('sections', cart.getSectionsToRender().map(section => section.id));
        body.append('sections_url', window.location.pathname);
        cart.setActiveElement(preview?.opener || document.activeElement);
      }
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        if (!cart) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        preview?.close();
        cart.classList.remove('is-empty');
        cart.renderContents(result);
      } catch (error) {
        this.error.textContent = error.message || this.dataset.error;
        this.error.hidden = false;
      } finally {
        this.busy = false;
        this.button.removeAttribute('aria-busy');
      }
    }
  });
}

if (!customElements.get('pacifica-quick-preview')) {
  customElements.define('pacifica-quick-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.dialog = this.querySelector('dialog');
      this.variants = JSON.parse(this.querySelector('[data-pf-variants]').textContent);
      this.selects = Array.from(this.querySelectorAll('[data-pf-option]'));
      this.button = this.querySelector('[type="submit"]');
      this.variantInput = this.querySelector('[name="id"]');
      this.image = this.querySelector('.pf-preview-photo img');
      this.originalImage = this.image?.getAttribute('src');
      this.originalSrcset = this.image?.getAttribute('srcset');
      this.details = this.querySelector('[data-pf-details]');
      this.productUrl = this.details.getAttribute('href');
      this.originalPrice = this.querySelector('[data-pf-price]').textContent;
      this.selects.forEach(select => select.addEventListener('change', () => this.updateVariant()));
      this.querySelector('[data-pf-close]').addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      });
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('pf-preview-open');
        this.opener?.focus();
      });
      this.querySelectorAll('[data-pf-quantity]').forEach(button => button.addEventListener('click', () => {
        const input = this.querySelector('[name="quantity"]');
        input.value = String(Math.max(1, (Number(input.value) || 1) + Number(button.dataset.pfQuantity)));
      }));
      this.updateVariant();
    }

    open(opener) {
      this.opener = opener;
      this.dialog.showModal();
      document.body.classList.add('pf-preview-open');
    }

    close() { this.dialog.close(); }

    updateVariant() {
      const values = this.selects.map(select => select.value);
      const complete = values.every(Boolean);
      const variant = complete ? this.variants.find(item => this.selects.length === 0 || item.options.every((value, index) => value === values[index])) : undefined;
      this.variantInput.value = variant?.id || '';
      this.button.disabled = !variant?.available;
      this.button.textContent = !complete ? this.dialog.dataset.chooseLabel : !variant ? this.dialog.dataset.unavailableLabel : variant.available ? this.dialog.dataset.addLabel : this.dialog.dataset.soldLabel;
      this.querySelector('.pf-cart-error').hidden = true;
      this.details.href = variant ? `${this.productUrl}?variant=${variant.id}` : this.productUrl;
      this.querySelector('[data-pf-price]').textContent = variant?.price || this.originalPrice;
      if (this.image) {
        this.image.src = variant?.image || this.originalImage;
        if (variant?.image) this.image.removeAttribute('srcset');
        else if (this.originalSrcset) this.image.setAttribute('srcset', this.originalSrcset);
      }
      this.selects.forEach((select, index) => {
        Array.from(select.options).forEach(option => {
          if (!option.value) return;
          option.disabled = !this.variants.some(item => item.options[index] === option.value && values.slice(0, index).every((value, previous) => !value || item.options[previous] === value));
        });
      });
    }
  });
  document.addEventListener('click', event => {
    const opener = event.target.closest('.pf-options-button[data-pf-preview]');
    if (!opener) return;
    const dialog = document.getElementById(opener.dataset.pfPreview);
    const preview = dialog?.closest('pacifica-quick-preview');
    if (!preview?.open || !dialog.showModal) return;
    event.preventDefault();
    preview.open(opener);
  });
}
